<ng-container *ngIf="message?.message_type === 'system'; else regularMessage">
  <div class="w-full flex justify-center my-2">
    <ion-label class="text-[10px] bg-[#f0f0f0] px-3 py-1 rounded-full text-[#6b7280] text-center">
      {{ message.text }}
    </ion-label>
  </div>
</ng-container>

<ng-template #regularMessage>
  <div [class]="message.type === 1 ? 'float-end items-end' : 'float-start items-start'" class="flex flex-col w-full">
    <div class="flex flex-col gap-1 text-white relative">
      <div [class]="message.type === 1 ? 'message-1' : 'message-0'" appLongPress (longPress)="copyMessage()">
        <!-- Mostramos imagen si el mensaje es de tipo imagen -->
        <img *ngIf="message.message_type === 'image' && message.image_url" [src]="message.image_url" alt="Imagen de chat"
          class="max-w-full rounded" style="cursor: pointer;" (click)="onImageClick(message.image_url)" />
        <!-- Mostramos texto -->
        <p class="text-[11px]">{{ message.text }}</p>
      </div>
      <div class="flex z-40 relative" [class]="message.type === 1 ? 'justify-end mr-1' : 'ml-1'">
        <ion-label class="text-[8px] font-medium" color="secondary">{{ message.date }}</ion-label>
      </div>
    </div>
  </div>
</ng-template>

